import { IconProps } from "./Icons";

export const IconSearch = ({
  width = 20,
  height = 20,
  color,
  variant = "stroke",
}: IconProps) => {
  if (variant === "fill") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M21.5308 20.4694L16.8368 15.7763C18.1973 14.1429 18.8757 12.0478 18.7309 9.92697C18.5861 7.8061 17.6293 5.82271 16.0593 4.38938C14.4894 2.95605 12.4274 2.18314 10.3021 2.23144C8.17687 2.27974 6.15205 3.14553 4.64888 4.6487C3.14571 6.15187 2.27993 8.17669 2.23163 10.3019C2.18333 12.4272 2.95623 14.4893 4.38956 16.0592C5.82289 17.6291 7.80629 18.586 9.92715 18.7308C12.048 18.8756 14.1431 18.1971 15.7765 16.8366L20.4696 21.5307C20.5393 21.6003 20.622 21.6556 20.713 21.6933C20.8041 21.731 20.9017 21.7505 21.0002 21.7505C21.0988 21.7505 21.1963 21.731 21.2874 21.6933C21.3784 21.6556 21.4612 21.6003 21.5308 21.5307C21.6005 21.461 21.6558 21.3783 21.6935 21.2872C21.7312 21.1962 21.7506 21.0986 21.7506 21C21.7506 20.9015 21.7312 20.8039 21.6935 20.7129C21.6558 20.6218 21.6005 20.5391 21.5308 20.4694ZM3.75021 10.5C3.75021 9.16501 4.14609 7.85996 4.88779 6.74993C5.62949 5.6399 6.6837 4.77474 7.9171 4.26384C9.1505 3.75295 10.5077 3.61928 11.8171 3.87973C13.1264 4.14018 14.3292 4.78306 15.2732 5.72706C16.2172 6.67106 16.8601 7.8738 17.1205 9.18317C17.381 10.4925 17.2473 11.8497 16.7364 13.0831C16.2255 14.3165 15.3603 15.3708 14.2503 16.1125C13.1403 16.8542 11.8352 17.25 10.5002 17.25C8.71061 17.248 6.99488 16.5363 5.72944 15.2708C4.464 14.0054 3.7522 12.2896 3.75021 10.5Z"
          fill={color}
        />
      </svg>
    );
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.25}
        d="M9.063 15.625a6.562 6.562 0 1 0 0-13.125 6.562 6.562 0 0 0 0 13.125ZM13.703 13.703 17.5 17.5"
      />
    </svg>
  );
};